import React, { useState, useEffect } from "react";
import '../styles/Nav.css';
import logo from '../assets/logo.png';

const Nav = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

    const [sucursales] = useState([
        { id: 1, nombre: "Av. Nueva Providencia 1881, oficina 1313", titulo: "Especialidades Av. Nueva Providencia" },
        { id: 2, nombre: "Fidel Oteiza 1971, oficina 302", titulo: "Especialidades Fidel Oteiza" },
        { id: 3, nombre: "Rengo 94, Oficina 31, Concepción", titulo: "Especialidades Concepción" },
    ]);

    const [especialidades] = useState([
        { id_especialidad: 4, nombre_especialidad: "Cardiología", id_sucursal: 1 },
        { id_especialidad: 20, nombre_especialidad: "Cirugía menor", id_sucursal: 1 },
        { id_especialidad: 1, nombre_especialidad: "Dermatología", id_sucursal: 1 },
        { id_especialidad: 8, nombre_especialidad: "Endocrinología Adulto", id_sucursal: 1 },
        { id_especialidad: 2, nombre_especialidad: "Neurología Adulto", id_sucursal: 1 },
        { id_especialidad: 5, nombre_especialidad: "Neurología Infantil", id_sucursal: 1 },
        { id_especialidad: 3, nombre_especialidad: "Nutricion", id_sucursal: 1 },
        { id_especialidad: 14, nombre_especialidad: "Psicología Adulto", id_sucursal: 1 },
        { id_especialidad: 7, nombre_especialidad: "Psicología Infanto-juvenil", id_sucursal: 1 },
        { id_especialidad: 9, nombre_especialidad: "Psiquiatría adulto", id_sucursal: 1 },
        { id_especialidad: 18, nombre_especialidad: "Psicología Adulto Fidel Oteiza", id_sucursal: 2 },
        { id_especialidad: 19, nombre_especialidad: "Psicología Infanto-juvenil Fidel Oteiza", id_sucursal: 2 },
        { id_especialidad: 15, nombre_especialidad: "Psicología Adulto Concepción", id_sucursal: 3 },
        { id_especialidad: 16, nombre_especialidad: "Psicología Infanto-juvenil Concepción", id_sucursal: 3 },
    ]);

    const [activeSubmenu, setActiveSubmenu] = useState(null);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 991);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const toggleSubmenu = (e, sucursalId) => {
        e.preventDefault();
        setActiveSubmenu(activeSubmenu === sucursalId ? null : sucursalId);
    };

    const isSubmenuOpen = (sucursalId) => activeSubmenu === sucursalId;

    return (
        <nav className="navbar navbar-expand-lg border-bottom shadow-sm px-4" id="Nav">
            <div className="container-fluid">
                <a className="navbar-brand me-auto" href="/">
                    <img src={logo} alt="Formed" height="40" />
                </a>

                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto gap-3">
                        <li className="nav-item dropdown">
                            <a
                                className="nav-link dropdown-toggle"
                                href="#"
                                id="especialidadesDropdown"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                Especialidades
                            </a>
                            <ul className="dropdown-menu" aria-labelledby="especialidadesDropdown">
                                {isMobile ? (
                                    // VERSIÓN MÓVIL: mostrar agrupadas por sede
                                    sucursales.map((sucursal) => (
                                        <React.Fragment key={sucursal.id}>
                                            <li className="dropdown-header fw-bold">{sucursal.titulo}</li>
                                            {especialidades
                                                .filter((esp) => esp.id_sucursal === sucursal.id)
                                                .map((esp) => (
                                                    <li key={esp.id_especialidad}>
                                                        <a
                                                            className="dropdown-item"
                                                            href={`/especialidad/${encodeURIComponent(esp.nombre_especialidad)}`}
                                                        >
                                                            {esp.nombre_especialidad}
                                                        </a>
                                                    </li>
                                                ))}
                                            <li><hr className="dropdown-divider" /></li>
                                        </React.Fragment>
                                    ))
                                ) : (
                                    // VERSIÓN ESCRITORIO: submenús por sede
                                    sucursales.map((sucursal) => (
                                        <li key={sucursal.id} className="dropdown-submenu">
                                            <a
                                                className="dropdown-item dropdown-toggle"
                                                href="#"
                                                onClick={(e) => toggleSubmenu(e, sucursal.id)}
                                            >
                                                {sucursal.nombre}
                                            </a>
                                            <ul className={`dropdown-menu ${isSubmenuOpen(sucursal.id) ? 'show' : ''}`}>
                                                {especialidades
                                                    .filter((esp) => esp.id_sucursal === sucursal.id)
                                                    .map((esp) => (
                                                        <li key={esp.id_especialidad}>
                                                            <a
                                                                className="dropdown-item"
                                                                href={`/especialidad/${encodeURIComponent(esp.nombre_especialidad)}`}
                                                            >
                                                                {esp.nombre_especialidad}
                                                            </a>
                                                        </li>
                                                    ))}
                                            </ul>
                                        </li>
                                    ))
                                )}
                            </ul>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/profesionales">Profesionales</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/presupuesto">Presupuesto Cirugía</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/aranceles-ecografias">Aranceles Ecografías</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="https://paciente-formed.mris.cl/MRISUMED/Pages/Portal/Patient/FORMED">Revisa tu ecografía</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/devoluciones">Devoluciones</a>
                        </li>
                        <li className="nav-item d-flex align-items-center">
                            <a className="nav-link" href="#">
                                <i className="bi bi-search" style={{ fontSize: "1.2rem" }}></i>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link btn btn-primary text-white px-4 py-2" href="/reserva" id="btnReservarHora">
                                Reservar Hora
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Nav;
